import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router';
import './App.css';
import Login from './pages/Login';
import Main from './pages/Main'; //Halaman utama setelah login
import { NotificationProvider } from './pages/NotifPopup';
import { ConfirmProvider } from './pages/ModalConfirm';
import { GlobalOpsiProvider } from './components/GlobalOpsi';
import 'nprogress/nprogress.css';
import { hasSessionToken } from './services/authSession';
import { APP_VERSION, APP_VERSION_META_NAME } from './appVersion';

const VERSION_CHECK_INTERVAL_MS = 60 * 1000;

function AppVersionMonitor() {
  useEffect(() => {
    let stopped = false;

    const checkVersion = async () => {
      try {
        const response = await fetch(`/?app-version-check=${Date.now()}`, {
          cache: 'no-store',
          credentials: 'same-origin',
          headers: { 'Cache-Control': 'no-cache' },
        });
        if (!response.ok || stopped) return;

        const html = await response.text();
        const latestVersion = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(`meta[name="${APP_VERSION_META_NAME}"]`)
          ?.getAttribute('content')
          ?.trim();

        if (!latestVersion || latestVersion === APP_VERSION) return;

        const refreshedFor = sessionStorage.getItem('tms_app_version_refresh');
        if (refreshedFor === latestVersion) return;
        sessionStorage.setItem('tms_app_version_refresh', latestVersion);
        window.location.reload();
      } catch (error) {
        // Pemeriksaan versi tidak boleh mengganggu aplikasi saat jaringan sementara gagal.
      }
    };

    checkVersion();
    const timer = window.setInterval(checkVersion, VERSION_CHECK_INTERVAL_MS);
    return () => {
      stopped = true;
      window.clearInterval(timer);
    };
  }, []);

  return null;
}

function PrivateRoute({ children }) {
  const token = hasSessionToken();
  return token ? children : <Navigate to="/login" />;
}

export default function App() {
  return (
      <ConfirmProvider>
      <NotificationProvider>
      <GlobalOpsiProvider>  
      <AppVersionMonitor />
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        <Route path="/main" element={<PrivateRoute><Main /></PrivateRoute>}/>
      </Routes>
      </GlobalOpsiProvider>
      </NotificationProvider>
      </ConfirmProvider>    
  );
}
